export const defaultLocale = "en";
export const localeOptions = [
    { id: 'en', name: 'English', icon: 'us' },
    { id: 'es', name: 'Spanish', icon: 'es' },
    { id: 'fr', name: 'French', icon: 'fr' },
    { id: 'ar', name: 'Arabic', icon: 'sa' },
];
